<template>
  <v-list>
    <v-list-item v-if="!readonly && !localonly">
      <v-list-item-content>Währung</v-list-item-content>
      <v-list-item-action
        ><CurrencyChoice v-model="modelValue.currency" />
      </v-list-item-action>
    </v-list-item>
    <v-list-item v-if="!nodetails">
      <v-list-item-content>Summe der Einzelbeträge</v-list-item-content>
      <v-list-item-action
        ><CurrencyValue v-model="sum" :currency="currency" />
      </v-list-item-action>
    </v-list-item>
    <v-list-item v-if="!nodetails">
      <v-list-item-content>Rundungsdifferenz</v-list-item-content>
      <v-list-item-action
        ><CurrencyValue v-model="difference" :currency="currency" />
      </v-list-item-action>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>Rechnungsbetrag </v-list-item-content>
      <v-list-item-action v-if="foreign">
        <CurrencyValue
          v-if="readonly"
          :value="
            modelValue.amount ? modelValue.amount : modelValue.amountForeign
          "
          :currency="currency"
        />
        <CurrencyInput
          v-else
          v-model="modelValue.amountForeign"
          :currency="currency"
        />
      </v-list-item-action>
      <v-list-item-action v-else>
        <CurrencyValue
          v-if="readonly"
          v-model="modelValue.amount"
          :currency="currency"
        />
        <CurrencyInput
          v-else
          v-model="modelValue.amount"
          :currency="currency"
        />
      </v-list-item-action>
    </v-list-item>
    <v-list-item v-if="check && !nodetails">
      <v-alert type="error">
        <strong>Der Rechnungsbetrag ist nicht vollständig aufgeteilt.</strong>
        Die maximale Toleranz beträgt <CurrencyValue v-model="tolerance" />
      </v-alert>
    </v-list-item>
  </v-list>
</template>
<script>
import { defineComponent } from "vue";
import CurrencyChoice from "common/components/CurrencyChoice.vue";
import CurrencyInput from "common/components/CurrencyInput.vue";
import CurrencyValue from "common/components/CurrencyValue.vue";
import { createInvoice } from "../../utils/finance";

export default defineComponent({
  components: {
    CurrencyChoice,
    CurrencyInput,
    CurrencyValue,
  },
  props: {
    readonly: { type: Boolean, default: false },
    localonly: { type: Boolean, default: false },
    value: {
      type: Object,
      default: createInvoice(),
    },
    nodetails: { type: Boolean, default: false },
  },
  data() {
    return {
      modelValue: createInvoice(),
    };
  },
  computed: {
    currency() {
      return this.modelValue.currency ? this.modelValue.currency.code : "CHF";
    },
    difference() {
      if (!this.modelValue) return 0;
      if (!this.foreign || this.modelValue.amount > 0) {
        return this.modelValue ? this.modelValue.amount - this.sum : 0;
      }
      return this.modelValue ? this.modelValue.amountForeign - this.sum : 0;
    },
    foreign() {
      return this.modelValue.currency && !this.modelValue.currency.local;
    },
    sum() {
      if (!this.modelValue) return 0;
      if (!this.modelValue.details) return;
      const details = this.modelValue.details;
      let result = 0;
      for (let i = 0; i < details.length; ++i) {
        if (!this.foreign || this.modelValue.amount > 0) {
          result += details[i].amount;
        } else {
          result += details[i].amountForeign;
        }
      }
      return result;
    },
    check() {
      if (!this.modelValue) return false;
      return Math.abs(this.difference) > this.tolerance;
    },
    tolerance() {
      if (!this.modelValue || !this.modelValue.details) return 0;
      return 0.02 * this.modelValue.details.length;
    },
  },
  watch: {
    difference() {
      if (!this.modelValue) return;
      if (!this.modelValue.details) return;
      if (this.check) {
        this.$emit("updateTolerance", false);
      } else {
        this.$emit("updateTolerance", true);
      }
    },
    value: {
      handler() {
        this.modelValue = this.value;
      },
      deep: true,
    },
  },
});
</script>
